import { useABExperimentBucket } from 'containers/ABExperiment';
import {
  orgDashboardCartRoute,
  orgDashboardCheckoutCartRoute,
} from 'modules/orgDashboard/orgDashboard.routes';

export function useABExperimentOrgDashboardCartRoute() {
  const singleScreenPaymentFlowEnabled =
    useABExperimentBucket({
      experimentId: 'SINGLE_SCREEN_PAYMENT_FLOW',
      defaultBucket: 'DISABLED',
    }) === 'ENABLED';

  return singleScreenPaymentFlowEnabled
    ? orgDashboardCheckoutCartRoute
    : orgDashboardCartRoute;
}
